import { Stack, useLocalSearchParams } from 'expo-router';
import React from 'react';

import SproutQABatchPage from '../../../llm-service/sprout/SproutQABatchPage';

export default function SproutQABatchRoute() {
    const { batchId } = useLocalSearchParams<{ batchId: string }>();

    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Suite Run',
                }}
            />
            <SproutQABatchPage batchId={batchId} />
        </>
    );
}
